import { render, staticRenderFns } from "./fragebogen.vue?vue&type=template&id=bb9666c2&scoped=true&"
import script from "./fragebogen.component.ts?vue&type=script&lang=ts&"
export * from "./fragebogen.component.ts?vue&type=script&lang=ts&"
import style0 from "./fragebogen.vue?vue&type=style&index=0&id=bb9666c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9666c2",
  null
  
)

export default component.exports